export type PropertyAggregation = GeneralPlatformProperties | JobsProperties | CompaniesProperties | TaskProperties;

export enum GeneralPlatformProperties {
    Dashboard = 'platform.menu.dashboard',
    CompanyDashboard = 'platform.menu.company_dashboard',
    Tasks = 'platform.menu.tasks',
    Jobs = 'platform.menu.jobs',
    Onboarding = 'platform.menu.onboardings',
    Candidates = 'platform.menu.candidates',
    Teams = 'platform.menu.teams',
    Users = 'platform.menu.users',
    Companies = 'platform.menu.companies',
    Employees = 'platform.menu.employees'
}

export enum JobsProperties {
    CreateRequisition = 'jobs.job.create',
    SeeOnlyAssigned = 'jobs.job.onlyAssigned',
    EditHardwareSoftware = 'jobs.job-detail.editHardwareSoftware',
    EditDetail = 'jobs.job-detail.edit',
    TriggerAiCallibration = 'jobs.job-detail.manualAiCalibration',
    CalibrateAfterEdit = 'jobs.job-detail.setCalibrationAfterEdit',
    ModifyStatus = 'jobs.job-detail.modifyStatus',
    AllowClientApproval = 'jobs.job-detail.clientApproval',
    AllowMoveToActive = 'jobs.job-detail.moveToActive',
    AddJobTask = 'jobs.job-detail.addJobTask',
    SeeMembers = 'jobs.job-detail.seeMembers',
    AddMembers = 'jobs.job-detail.addMember',
    DeleteMember = 'jobs.job-detail.deleteMember',
    SeeMemberDetail = 'jobs.job-detail.seeMemberDetail',
    AssignTaskToMember = 'jobs.job-detail.assignTaskToMember',
    SeePipeline = 'jobs.job-detail.seePipeline',
    MovePipelineStage = 'jobs.job-detail.movePipelineStage',
    ForceFeedbackOnPipelineUpdate = 'jobs.job-detail.forceFeedbackOnPipelineUpdate',
    AllowedCandidateOrPipelineStatus = 'jobs.job-detail.allowedCandidateOrPipelineStatus',
    MinFeedbackLengthChars = 'jobs.job-detail.minFeedbackLengthChars',
    SeeCandidates = 'jobs.job-detail.seeCandidates',
    SeeApplication = 'jobs.application.seeApplication',
    AllowRemoveFromJob = 'jobs.application.removeFromJob',
    AllowAddFeedback = 'jobs.application.addFeedback',
    AllowPrivateFeedbacks = 'jobs.application.privateFeedback',
    UpdateStatus = 'jobs.application.updateStatus',
    ForceFeedbackOnStatusUpdate = 'jobs.application.forceFeedbackOnStatusUpdate',
    ModifyTestScore = 'jobs.application.testScore',
    AddTaskForCandidate = 'jobs.application.addTaskForCandidate',
    SeeDevices = 'jobs.application.seeDevices',
    AddDevices = 'jobs.application.addDevices',
    RemoveDevices = 'jobs.application.removeDevices'
}

export enum CompaniesProperties {
    SeeAll = 'companies.companies.seeAll',
    EditCompany = 'companies.company-detail.edit',
    AddCompany = 'companies.company-detail.add',
    SeeDetails = 'companies.company-detail.seeDetails',
    SeeOwnDetail = 'companies.company-detail.seeOwnDetail',
    AddComments = 'companies.company-detail.addComment',
    SeeComments = 'companies.company-detail.seeComment',
    AllowPrivateComments = 'companies.company-detail.allowPrivateComments',
    DeleteComment = 'companies.company-detail.deleteComment',
    SeeMembers = 'companies.company-detail.seeMembers',
    InviteNewMembers = 'companies.company-detail.inviteNewMembers',
    AddExistingUser = 'companies.company-detail.addExistingUser',
    SeeDocuments = 'companies.company-detail.seeDocuments',
    AddDocuments = 'companies.company-detail.addDocuments',
    AllowDeleteDocument = 'companies.company-detail.deleteDocument',
    ShowDeletedDocuments = 'companies.company-detail.showDeletedDocuments',
    DownloadDocuments = 'companies.company-detail.downloadDocuments',
    SeeJobs = 'companies.company-detail.seeJobs',
    SeeInterviews = 'companies.company-detail.seeInterviews',
    AddTaskForCompany = 'companies.company-detail.addTask'
}

export enum TaskProperties {
    Filter = 'tasks.task.filter',
    AdminFilter = 'tasks.task.adminFilter',
    Create = 'tasks.task.create',
    EditDetails = 'tasks.task.editDetails',
    AddComment = 'tasks.task.addComment',
    ChangeAssignee = 'tasks.task.changeAssignee',
    ChangePriority = 'tasks.task.changePriority',
    ChangeDueDate = 'tasks.task.changeDuedate',
    Status = 'tasks.task.status',
    ForceFeedbackOnStatusChange = 'tasks.task.forceFeedbackOnStatusUpdate',
    MinFeedbackLength = 'tasks.task.minFeedbackLengthChars',
    AddMember = 'tasks.task.addMember',
    DeleteMember = 'tasks.task.deleteMember',
    StatusUpdate = 'tasks.task.statusUpdate',
    OnlyAssigned = 'tasks.task.onlyAssigned',
    AllowArchive = 'tasks.task.archive'
}
